import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { UserContext } from '../context/User';
import Footer from './Footer';
import './Layout.css';
import Styles from "./Layout.module.css";

export class Layout extends Component {
  static displayName = Layout.name;
  static contextType = UserContext;

  render() {
    return (
      <div className={this.context.isHomeowner()
        ? Styles.layoutBckImageSvg : Styles.layoutBckImageContractorSvg}>
        <NavMenu />
        <Container className={`main-app-container ${Styles.container}`}>
          {this.props.children}
        </Container>
        <Footer />
      </div>
    );
  }
}
